import { render, staticRenderFns } from "./form-attendances.view.vue?vue&type=template&id=12868909&scoped=true&"
import script from "./form-attendances.view.vue?vue&type=script&lang=ts&"
export * from "./form-attendances.view.vue?vue&type=script&lang=ts&"
import style0 from "./form-attendances.view.vue?vue&type=style&index=0&id=12868909&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12868909",
  null
  
)

export default component.exports